import { getJobTitle } from './GraphQL/Queries/roleJobTitleQuery';
import * as roleJobtitleQuery from './GraphQL/Queries/roleJobTitleQuery';
import { RoleJobTitleVariables } from './GraphQL/Variables/roleJobTitle';

import axiosGraphQL from './GraphQL/axiosGraphQL';
const RoleJobTitleApis = {
  getAllJobTitle: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: roleJobtitleQuery.getJobTitle,
      variables: RoleJobTitleVariables.getAllJobTitle(params),
    });
  },
  updateJobTitle: async (data: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: roleJobtitleQuery.updateJobTitle,
      variables: RoleJobTitleVariables.updateJobTitle(data),
    });
  },
  getJobTitleComboBox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: roleJobtitleQuery.GET_JOBTITLE_COMBOBOX,
      variables: RoleJobTitleVariables.getJobTitleComboBoxVariable(),
    });
  },
  // getAllRoleCombobox: async () => {
  //   return await axiosGraphQL.post('/graphql', {
  //     query: `query GetRoleComboBox ($input: TroleWhereInput) {
  //       getRole (where: $input ) {
  //           pageInfo{
  //               currentPage
  //               hasNextPage
  //               hasPreviousPage
  //               itemsPerPage
  //               totalItems
  //               totalPages
  //           }
  //           items {
  //               id
  //               name
  //           }
  //       }
  //   }`,
  //     variables: {
  //       items: {},
  //     },
  //   });
  // },
};

export default RoleJobTitleApis;
